export interface FeatureFlagContext {
  ff_autopaySettings: boolean;
  ff_portalBalanceForward: boolean;
  ff_applicationsEnabled: boolean;
  ff_applicationsEnabledSettings: {
    ladderLife: boolean;
  };
  ff_econsentEnabled: boolean;
  ff_exactPaymentsOnly: boolean;
}

export const FEATURE_FLAG_CONTEXT_DEFAULT: FeatureFlagContext = {
  ff_autopaySettings: true,
  ff_portalBalanceForward: false,
  ff_applicationsEnabled: false,
  ff_applicationsEnabledSettings: {
    ladderLife: false,
  },
  ff_econsentEnabled: false,
  ff_exactPaymentsOnly: false,
};
